import React, { useState } from 'react';
import ModalInfo from './modal-info';


const InjuriesModal = ({ injurie, onSave, onCancel }) => {
  const [localText, setLocalText] = useState(injurie.summary || '');

  const handleConfirm = () => {
    onSave(localText);
  };

  return (
    <ModalInfo
      onCancel={onCancel}
      onConfirm={handleConfirm}
      loader={false}
      buttonConfirm={true}
    >
      <div className="d-flex flex-column ">
        <div
          className="d-flex justify-content-center pb-3"
          style={{ borderBottom: "0.5px solid #B6C1CE", textAlign: "center" }}
        >
          <span className="label-step">
            <strong>Lesiones y dolores registrados</strong>
          </span>
        </div>
        <div className="p-2 mt-2">
          <textarea
            className="input_info_athlete_input textarea-place"
            value={localText}
            onChange={(e) => setLocalText(e.target.value)}
            placeholder="Escribe cada lesión en una nueva línea"
            rows={6}
          />
        </div>
      </div>
    </ModalInfo>
  );
};

export default InjuriesModal;